<script>
	import { getContext, createEventDispatcher } from 'svelte'
	import { styles } from '../library/scripts/styles.js'
	import Button from '../library/LayoutStuff/Button.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let message = 'here the error message'
	export let message2 = ''
	export let showOkButton = true
	export let showCancelButton = true
	export let spinner = false
	export let spinnerSize = '4vw'
	export let spinnerInfo = 'update'
	export let alertMessage = 'Alert messsage'
	let showSpinner = false

	const globals = getContext('globals')
	const colorError = globals.colorError
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const adminInputBorder = globals.adminInputBorder
	const adminColorMain = globals.adminColorMain
	const adminInputBg = globals.adminInputBgFocus
	const adminBgDark = globals.adminBgDark

	let dispatch = new createEventDispatcher()

	$: if (!showCancelButton) {
		if (spinner) showSpinner = true
	}

	const send_ok = async () => {
		if (spinner) showSpinner = true
		dispatch('alertok')
	}
	const send_abort = () => {
		showSpinner = false
		dispatch('alertclose')
	}
</script>

<main use:styles={{ adminBgDark }}>
	<div class="title" use:styles={{ colorError, fsS }}>{alertMessage}</div>
	{#if !showSpinner}
		<div class="message" use:styles={{ adminColorMain, fsS }}>{message}</div>
		<div class="message error" use:styles={{ adminColorMain, fsS, colorError }}>{message2}</div>
	{/if}

	{#if spinner && showSpinner}
		<div class="spinner">
			<Spinner color="hsl(0,0%,60%)" size={spinnerSize} fontSize={fsXS} info={spinnerInfo} />
		</div>
	{/if}

	<div class="buttonContainer">
		{#if showOkButton}
			<button on:click={send_ok} use:styles={{ fsXS, adminInputBorder, adminColorMain, adminInputBg }}>ok</button>
		{/if}

		{#if showCancelButton}
			<button on:click={send_abort} use:styles={{ fsXS, adminInputBorder, adminColorMain, adminInputBg }}>close</button>
		{/if}
	</div>
</main>

<style>
	main {
		position: relative;
		display: flex;
		flex-direction: column;
		width: clamp(280px, 32vw, 500px);
		height: 250px;
		margin: 2%;
		align-items: center;
		border: 1px solid white;
		background-color: var(--adminBgDark);
	}

	button {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: var(--fsXS);
		background: transparent;
		border: 1px solid var(--adminInputBorder);
		color: var(--adminColorMain);
		cursor: pointer;
		padding: 5px;
		margin: 5px;
		outline: none;
		width: clamp(40px, 5.2vw, 80px);
	}

	button:hover {
		background: var(--adminInputBg);
	}

	.title {
		display: flex;
		justify-content: center;
		width: 100%;
		padding: 10px;
		border-bottom: 1px solid white;
		color: var(--colorError);
		font-size: var(--fsXSX);
	}

	.message {
		padding-top: 15px;
		color: var(--adminColorMain);
		font-size: var(--fsS);
		text-align: center;
		white-space: pre-wrap;
	}

	.error {
		color: var(--colorError);
	}

	.spinner {
		margin-top: 30px;
	}

	.buttonContainer {
		position: absolute;
		bottom: 15px;
		right: 15px;
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}
</style>
